module.exports = __webpack_public_path__ + "img/245.f7bc74df.png";